const isDevelopment = process.env.NODE_ENV === 'development';

module.exports = {
  isDevelopment,
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'n8p3h7hj',
    dataset:
      process.env.GATSBY_SANITY_DATASET || isDevelopment
        ? 'development'
        : 'production',
  },
};
